import { useToast } from '@chakra-ui/react';

export const useErrorIndicator = () => {
  const toast = useToast();

  const showError = (message: string, description?: string) => {
    toast({
      title: message,
      description: description,
      status: 'error',
      duration: 9000,
      isClosable: true,
    });
  };

  const showWarning = (message: string, description?: string) => {
    toast({
      title: message,
      description: description,
      status: 'warning',
      duration: 9000,
      isClosable: true,
    });
  };

  return { showError, showWarning };
};
